import PropTypes from 'prop-types';

const displayName = 'AdminAccount';
const propTypes = {};
const defaultProps = {};

export default { displayName, propTypes, defaultProps };
